module.exports = __webpack_public_path__ + "img/medal4.e2d7e413.png";